import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import { Dropdown, DropdownItem, DropdownTitle } from 'components/Dropdown'
import Icon from 'components/Icon'
import BulkActionJobErrorDialog from 'jobs/views/BulkActionJobErrorDialog'
import BulkCopyJobsDialog from 'jobs/views/BulkCopyJobDialog'
import BulkCopyJobsSuccessDialog from 'jobs/views/BulkCopyJobsSuccessDialog'
import TransferJobDialog from 'jobs/views/JobRoot/Job/TransferJobDialog'
import NotifyProsOfUnclaimedJobsDialog from 'jobs/views/JobManagement/NotifyProsOfUnclaimedJobsDialog'
import JobManagementViewModel from '../JobManagementViewModel'
import JobsViewerHeader from '../JobsViewerHeader'
import JobsTable from '../JobsTable'
import UpcomingConsultationPreview from 'jobs/views/UpcomingConsultationPreview'
import styles from './JobsViewer.sass'

interface JobsViewerProps {
  vm: JobManagementViewModel
}

export default observer(function JobsViewer({ vm }: JobsViewerProps) {
  return (
    <div className={styles.root}>
      <UpcomingConsultationPreview vm={vm.upcomingConsultationPreviewVM} />
      <div className={styles.jobsViewer}>
        <JobsViewerTitle vm={vm} />
        <JobsViewerHeader vm={vm} />
        <div className={styles.jobsTableContainer}>
          <JobsTable vm={vm} />
          <BulkCopyJobsDialog vm={vm.selectionVM.bulkCopyVM} />
          <TransferJobDialog vm={vm.selectionVM.transferJobVM} />
          <BulkActionJobErrorDialog vm={vm.selectionVM.bulkActionErrorVM} />
          <BulkCopyJobsSuccessDialog
            vm={vm.selectionVM.bulkCopyJobsSuccessVM}
          />
          <NotifyProsOfUnclaimedJobsDialog
            vm={vm.notifyProsOfUnclaimedJobsVM}
          />
        </div>
      </div>
    </div>
  )
})

export const JobsViewerTitle = observer(function JobsViewerTitle({
  vm,
}: JobsViewerProps) {
  return (
    <div className={styles.jobsViewerTitleContainer}>
      <h3 className={styles.jobsViewerTitleText}>Jobs</h3>
      <JobCount vm={vm} />
    </div>
  )
})

export const JobCount = observer(function JobCount({ vm }: JobsViewerProps) {
  const totalJobs = vm.searcher.totalJobs

  return vm.selectionVM.canViewArchivedJobs ? (
    <div className={styles.jobCountContainer}>
      <Dropdown
        autoDismiss
        button={
          <Button type="text" className={styles.jobViewerActions}>
            {vm.jobViewingActionsLabel}
            <span className={styles.resultCount}>({totalJobs ?? 0})</span>
            <Icon name="dropdown" />
          </Button>
        }
      >
        <DropdownTitle>Jobs</DropdownTitle>
        <DropdownItem onClick={() => vm.viewOnlyActiveJobs()}>
          Active
        </DropdownItem>
        <DropdownItem onClick={() => vm.viewOnlyArchivedJobs()}>
          Archived
        </DropdownItem>
      </Dropdown>
    </div>
  ) : (
    <div className={styles.jobCountContainer}>
      Jobs
      <span className={styles.resultCount}>({totalJobs ?? 0})</span>
    </div>
  )
})
